import { render, staticRenderFns } from "./filtersCom.vue?vue&type=template&id=73188801&scoped=true&"
import script from "./filtersCom.vue?vue&type=script&lang=js&"
export * from "./filtersCom.vue?vue&type=script&lang=js&"
import style0 from "./filtersCom.vue?vue&type=style&index=0&id=73188801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73188801",
  null
  
)

export default component.exports